import { useState, useCallback } from 'react';
import { evaluateDeviceTrust, refreshDeviceTrustStatus } from '../services/deviceTrust';
import type { DeviceTrustResult } from '../types';

export function useDeviceTrust() {
  const [isDeviceTrusted, setIsDeviceTrusted] = useState(true);

  const applyTrustResult = useCallback((result: DeviceTrustResult) => {
    setIsDeviceTrusted(result.trusted);
  }, []);

  const evaluateAndSet = useCallback(async (userId: string) => {
    const result = await evaluateDeviceTrust(userId);
    setIsDeviceTrusted(result.trusted);
    return result;
  }, []);

  const refreshDeviceTrust = useCallback(async (userId: string) => {
    const trusted = await refreshDeviceTrustStatus(userId);
    setIsDeviceTrusted(trusted);
  }, []);

  const reset = useCallback(() => {
    setIsDeviceTrusted(true);
  }, []);

  return {
    isDeviceTrusted,
    evaluateAndSet,
    refreshDeviceTrust,
    reset,
  };
}
